import { useCallback } from "react";

import { modules, useObjectMemo } from "byzantine";

export const useTemplateSelector = () => {
  const {
    sortedFedwireTemplateIds,
    showManageTemplatesUI,
    selectedTemplateId,
    onSelectTemplate,
    method,
    error,
    resetForm,
  } = modules.wireTemplates.useTemplateSelector();

  const manageTemplates = useCallback(() => {
    resetForm();
    window.location.assign("/templates/wire");
  }, [resetForm]);

  return useObjectMemo({
    showManageTemplatesUI,
    sortedFedwireTemplateIds,
    selectedTemplateId,
    onSelectTemplate,
    manageTemplates,
    method,
    error,
  });
};
